import React, { useState, useEffect } from "react";
import {
  getStarPilotMonteChatHistory,
  getSuggestionBoxChatHistory,
  getPrescriptionHistory,
  getProfile,
  prescription,
} from "../../../api/apiHandler";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { useParams, useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import moment from "moment-timezone";
import { EmailPrescriptionPopup } from "../../../modal/emailPrescriptionPopup";
import PatientInfoPop from "../prescription/DoctorInfoPop/index.jsx";
import PatientInfoEditPop from "../prescription/PatientInfoEditPop/index.jsx";
import QRCodePop from "../prescription/QrCodePop/index.jsx";
import PriestMeetingRecord from "./PriestMeetingRecord.js";
import queryString from "query-string";
import NotesModal from "../prescription/Notes/PrescriptionNotes.js";
import { TbInfoTriangle } from "react-icons/tb";
function MeetingStatus() {
  const navigate = useNavigate();
  const [starpilotChat, setStarpilotChat] = useState([]);
  console.log(starpilotChat, "SingleUserRespS2p");
  let role = localStorage.getItem("user_login_type_role");

  const params = queryString.parse(window.location.search);
  const [suggestionBoxChat, setSuggestionBoxChat] = useState([]);
  const [tempPrescription, setTempPrescription] = useState([]);
  const [mainPrescription, setMainPrescription] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [medicineList, setMedicineList] = useState();
  const [patientDataDetails, setPatientDataDetails] = useState(null);
  const [patientinfoData, setPatientInfoData] = useState({});
  const [patiendInfo, setPatientInfo] = useState();
  const [patiendInfoEdit, setPatientInfoEdit] = useState();
  const [meetingData, setMeetingData] = useState({});
  const [qrCode, setQrCode] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [doctorDataDetails, setDoctorDataDetails] = useState(null);
  const { meetingId } = useParams();
  const [typepres, settypepres] = useState();
  const patientid =
    tempPrescription[0]?.patient_id || mainPrescription[0]?.patient_id;
  console.log("meetingId===>", meetingId);
  console.log(patientDataDetails, "patientDataDetails");

  useEffect(() => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    getStarPilotMonteChatHistory({ meeting_id: meetingId }).then((res) => {
      var response = JSON.parse(res);
      console.log("SingleUserRespS2p", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        if (response.data.response && response.data.response.length > 0) {
          setStarpilotChat(response.data.response);
        } else {
          setStarpilotChat([]);
        }
        // Swal.close();
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });

    getPrescriptionHistory({ meeting_id: meetingId }).then((res) => {
      Swal.close();
      var response = JSON.parse(res);
      console.log("response344434", response.data);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setMeetingData(response?.data?.getMeetingDataForPatient);
        // prescripitonTemp, prescripitonMain:
        setDoctorDataDetails(response?.data?.meetingUsers);
        setQrCodeUrl(response.data.qrCode);
        setPatientDataDetails(response?.data?.meetingUsers);
        setPatientInfoData(response?.data?.meetingUsers.patient);
        if (
          response.data.prescripitonTemp &&
          response.data.prescripitonTemp.length > 0
        ) {
          setTempPrescription((prev) => [
            ...response.data.prescripitonTemp,
            ...prev,
          ]);
        } else {
          setTempPrescription([]);
        }
        if (
          response.data.prescripitonMain &&
          response.data.prescripitonMain.length > 0
        ) {
          setMainPrescription((prev) => [
            ...response.data.prescripitonMain,
            ...prev,
          ]);
        } else {
          setMainPrescription([]);
        }
        // Swal.close();
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });

    getSuggestionBoxChatHistory({ meeting_id: meetingId }).then((res) => {
      // console.log('response===>', res)
      Swal.close();
      var response = JSON.parse(res);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        if (response.data.response && response.data.response.length > 0) {
          setSuggestionBoxChat((prev) => [...response.data.response, ...prev]);
        } else {
          setSuggestionBoxChat([]);
        }
        // Swal.close();
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
    getPatientDetails();
    // Swal.close();
  }, []);

  const handlePatientInfo = (type) => {
    setPatientInfo(!patiendInfo);
    settypepres(type);
  };
  const handlePatientEditInfo = (type) => {
    setPatientInfoEdit(!patiendInfoEdit);
    settypepres(type);
  };
  const isOpenMailModal = (prescription) => {
    setMedicineList(prescription);
    setIsOpen(true);
  };

  const getPatientDetails = () => {
    getProfile({}).then((response) => {
      response = JSON.parse(response);
      console.log("response", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        // setPatientDataDetails(response.data);
      }
      // Swal.close()
    });
  };

  const autoPrescription = (type) => {
    const meetingDataObj = {
      meeting_id: meetingId,
      appointment_id: meetingData?.appointment_id,
      patient_id:
        tempPrescription[0]?.patient_id || mainPrescription[0]?.patient_id,
      presriptionType: type,
    };
    const serializedObject = queryString.stringify(meetingDataObj);
    let url;
    if (role == "4") {
      url = `/priest/auto-prescription?${serializedObject}`;
    } else if (role == "1") {
      url = `/patient/auto-prescription?${serializedObject}`;
    } else {
      url = `/doctor/auto-prescription?${serializedObject}`;
    }
    setTimeout(() => {
      window.open(url, "_blank");
    }, 500);
  };

  const handleQRCode = (type) => {
    setQrCode(!qrCode);
    settypepres(type);
  };
  const handleSendRx = () => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    var params = {
      patient_id: patientinfoData.id,
      meeting_id: meetingData.meeting_id,
      appointment_id: meetingData.appointment_id,
      prescription_date: moment().utc().format("YYYY-MM-DD"),
      first_name: patientinfoData != null ? patientinfoData.first_name : null,
      last_name: patientinfoData != null ? patientinfoData.last_name : null,
      age: patientinfoData != null ? patientinfoData.age : 0,
      date_of_birth: null,
      gender: null,
      county: patientinfoData != null ? patientinfoData.country : null,
      state: patientinfoData != null ? patientinfoData.state : null,
      city: patientinfoData != null ? patientinfoData.city : null,
      address: patientinfoData != null ? patientinfoData.address : null,
      zipcode: null,
      physician_first_name: null,
      physician_last_name: null,
      additional_direction: null,
      permission_code: null,
    };
    console.log("paramssssssss333", params);
    prescription(params).then((response) => {
      response = JSON.parse(response);
      console.log("response", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        const sendRxObj = {
          prescription_id: response.data.id,
          patient_id: patientinfoData?.id,
          appointment_id: meetingData.appointment_id,
        };
        console.log("sendRxObj", sendRxObj);
        if (role == "4") {
          navigate("/priest/chemist-list", { state: sendRxObj });
        } else {
          navigate("/doctor/chemist-list", { state: sendRxObj });
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      Swal.close();
    });
  };
  const [openNotes, setOpenNotes] = useState(false);

  const handleViewNotes = (prescription) => {
    setMedicineList(prescription);
    setOpenNotes(true);
  };

  return (
    <>
      <EmailPrescriptionPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        medicineList={medicineList}
        doctorData={patientDataDetails}
        patientData={patientinfoData}
      />
      <PatientInfoPop
        patientData={patientDataDetails?.patient}
        patiendInfo={patiendInfo}
        setPatientInfo={setPatientInfo}
        tempPrescription={tempPrescription}
        mainPrescription={mainPrescription}
        typepres={typepres}
      />
      <PatientInfoEditPop
        patiendInfo={patiendInfoEdit}
        setPatientInfo={setPatientInfoEdit}
        setPatientInfoData={setPatientInfoData}
        patientinfoData={patientDataDetails?.doctor}
        tempPrescription={tempPrescription}
        mainPrescription={mainPrescription}
        typepres={typepres}
      />
      <QRCodePop
        datePresc={moment().utc().format("D MMMM YYYY")}
        qrCodeUrl={qrCodeUrl}
        docData={doctorDataDetails}
        patientData={patientinfoData}
        medicineList={medicineList}
        qrCode={qrCode}
        setQrCode={setQrCode}
        tempPrescription={tempPrescription}
        mainPrescription={mainPrescription}
        typepres={typepres}
      />
      <NotesModal show={openNotes} onClose={setOpenNotes} note={medicineList} />
      <Header />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <p className="font_22 font_600 mb-0">Meeting Record </p>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={role == "4" ? "/priest/home" : "/doctor/home"}
                    className="font_14"
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active font_14"
                  aria-current="page"
                >
                  Meeting Record
                </li>
              </ol>
            </nav>
          </div>
          <div className="card">
            <div className="card-body doctor-table-card">
              <div className="py-3">
                <h4 className="m-0 fw-bold">Star Pilot Chat</h4>
                <div
                  className="bg-light rounded p-3 overflow-auto search-sec"
                  style={{ maxHeight: 400 }}
                >
                  {starpilotChat.length > 0 &&
                    starpilotChat.map((item) => (
                      <div className="py-2">
                        <div className="ans-sub-block">
                          <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock">
                            <div className="aiicon">
                              <img
                                src="/assets/images/logo.png"
                                alt="profile"
                                className="profile"
                              />
                            </div>
                            <div>
                              <p className="mb-2 font_16 text-blue font_600">
                                Monte Sereno (
                                {new Date(item?.createdAt).toUTCString()})
                              </p>
                              <pre
                                id="scripture-block"
                                className="mb-2 text-justify white-space-pre"
                                dangerouslySetInnerHTML={{
                                  __html: item?.response,
                                }}
                              />

                              <p className="mb-2   font_16 text-blue font_600">
                                {item?.prompt?.role} (
                                {new Date(item?.createdAt).toUTCString()})
                              </p>
                              <pre className="mb-2   white-space-pre">
                                {item?.prompt?.transcript}
                              </pre>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {starpilotChat.length <= 0 && (
                    <p className="m-0 text-center">No Data Found!</p>
                  )}
                </div>
              </div>
              <div className="py-3">
                <h4 className="m-0 fw-bold">Suggestion Box</h4>
                <div
                  className="bg-light rounded p-3 overflow-auto search-sec"
                  style={{ maxHeight: 400 }}
                >
                  {suggestionBoxChat?.length > 0 &&
                    suggestionBoxChat?.map((item, index) => (
                      <div className="py-2" key={index}>
                        <div className="ans-sub-block">
                          <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock">
                            <div className="aiicon">
                              <img
                                src="/assets/images/logo.png"
                                alt="profile"
                                className="profile"
                              />
                            </div>
                            <div>
                              <p className="mb-2 font_16 text-blue font_600">
                                Monte Sereno (
                                {new Date(item?.createdAt).toUTCString()})
                              </p>
                              <pre className="mb-2 text-justify white-space-pre">
                                {item?.response}
                              </pre>
                              {item?.prompt?.map((user) => (
                                <>
                                  <p className="mb-2   font_16 text-blue font_600">
                                    {user?.role}
                                  </p>
                                  <pre className="mb-2   white-space-pre">
                                    {user?.transcript}
                                  </pre>
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {suggestionBoxChat?.length <= 0 && (
                    <p className="m-0 text-center">No Data Found!</p>
                  )}
                </div>
              </div>
              {role == "4" || params?.isPriestMeeting == "true" ? (
                <>
                  <div className="py-3">
                    <section className="doctorsec-pad share-medical pb-0">
                      <div className="container">
                        <div className="card">
                          <div className="card-body doctor-table-card">
                            <PriestMeetingRecord
                              medicineList={tempPrescription}
                              handleQRCode={handleQRCode}
                              handlePatientEditInfo={handlePatientEditInfo}
                              isOpenMailModal={isOpenMailModal}
                              handlePatientInfo={handlePatientInfo}
                              meetingData={meetingData}
                              from="singleUser"
                              type="final_pres"
                              settypepres={settypepres}
                            />
                          </div>{" "}
                        </div>{" "}
                      </div>{" "}
                    </section>
                  </div>
                  <div className="py-3">
                    <section className="doctorsec-pad share-medical pb-0">
                      <div className="container">
                        <div className="card">
                          <div className="card-body doctor-table-card">
                            <PriestMeetingRecord
                              medicineList={tempPrescription}
                              handleQRCode={handleQRCode}
                              handlePatientEditInfo={handlePatientEditInfo}
                              isOpenMailModal={isOpenMailModal}
                              handlePatientInfo={handlePatientInfo}
                              meetingData={meetingData}
                              from="singleUser"
                              type="tempPres"
                              settypepres={settypepres}
                            />
                          </div>{" "}
                        </div>{" "}
                      </div>{" "}
                    </section>
                  </div>
                </>
              ) : (
                <>
                  <div className="py-5">
                    <div className="d-flex justify-content-between align-center">
                      <h4 className="m-0 fw-bold">Prescription</h4>{" "}
                      <button
                        className="px-3 py-2 rounded d-inline-flex align-items-center gap-2 bg-red-50 border border-red-200 shadow-sm hover:bg-red-100 transition-all"
                        onClick={() => handleViewNotes(mainPrescription)}
                        style={{ maxWidth: "max-content" }}
                      >
                        <TbInfoTriangle className="text-danger" size={20} />
                        <span className="fw-semibold text-red-700">Notes</span>
                      </button>
                    </div>
                    <section className="doctorsec-pad share-medical pb-0">
                      <div className="container">
                        <div className="card">
                          <div className="card-body doctor-table-card">
                            <div className="table-responsive">
                              <table className="doctor-list-table table table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="row">Page</th>
                                    <th>Name of Drug</th>
                                    <th>Strength</th>
                                    <th>Strength Type</th>
                                    <th>Unit</th>
                                    <th>Form</th>
                                    <th>Dose</th>
                                    <th>Frequency</th>
                                    <th>Intakes or Applications</th>
                                    <th>Route</th>
                                    <th>Refills</th>
                                    <th>Quantity</th>
                                    <th>Comments</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {mainPrescription &&
                                    mainPrescription?.map((item, index) => {
                                      return (
                                        <tr id={item?.id} key={index}>
                                          <td scope="row">{index + 1}</td>
                                          <td>
                                            <h3 className="doc-details">
                                              {item?.medication_name}
                                            </h3>
                                          </td>

                                          <td>{item?.strength}</td>
                                          <td>{item?.strength_type}</td>
                                          <td>{item?.units}</td>
                                          <td>{item?.form}</td>
                                          <td>{item?.dose}</td>
                                          <td>{item?.frequency}</td>
                                          <td>{item?.intake}</td>
                                          <td>{item?.route}</td>
                                          <td>{item?.refills}</td>
                                          <td>{item?.quantity}</td>
                                          <td>{item?.comments}</td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                            <PocPrescriptionWrpper className="d-flex mt-3 align-items-center justify-content-between flex-wrap gap-10">
                              <button
                                disabled={mainPrescription.length == 0}
                                onClick={() => handleQRCode("prescription")}
                                className={`submit-btn d-inline-flex justify-content-center ${
                                  mainPrescription.length == 0 ? "disabled" : ""
                                }`}
                                style={{ maxWidth: "max-content" }}
                              >
                                QR Codes
                              </button>

                              {(meetingData?.check && <></>) || (
                                <button
                                  disabled={mainPrescription.length == 0}
                                  // className="submit-btn justify-content-center"
                                  className={`submit-btn d-inline-flex justify-content-center ${
                                    mainPrescription.length == 0
                                      ? "disabled"
                                      : ""
                                  }`}
                                  style={{ maxWidth: "max-content" }}
                                  onClick={handleSendRx}
                                >
                                  Send Rx
                                </button>
                              )}
                              <button
                                onClick={() =>
                                  handlePatientInfo("prescription")
                                }
                                className="submit-btn d-inline-flex justify-content-center"
                                style={{ maxWidth: "max-content" }}
                              >
                                Patient Info
                              </button>
                              <button
                                disabled={mainPrescription.length == 0}
                                onClick={() => autoPrescription("final_pres")}
                                className={
                                  mainPrescription.length == 0
                                    ? "submit-btn d-inline-flex justify-content-center disabled"
                                    : "submit-btn d-inline-flex justify-content-center"
                                }
                                style={{ maxWidth: "max-content" }}
                              >
                                Auto Prescription
                              </button>
                              <button
                                onClick={() =>
                                  isOpenMailModal(mainPrescription)
                                }
                                className={
                                  mainPrescription?.length === 0
                                    ? "submit-btn d-inline-flex justify-content-center disabled"
                                    : "submit-btn d-inline-flex justify-content-center"
                                }
                                style={{
                                  maxWidth: "max-content",
                                }}
                                disabled={mainPrescription?.length === 0}
                              >
                                Mail Prescription
                              </button>

                              <button
                                onClick={() =>
                                  handlePatientEditInfo("prescription")
                                }
                                className="submit-btn d-inline-flex  justify-content-center"
                                style={{ maxWidth: "max-content" }}
                              >
                                Doctor Info
                              </button>
                            </PocPrescriptionWrpper>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="py-5">
                    <div className="d-flex justify-content-between align-center">
                      <h4 className="m-0 fw-bold">Temporary Prescription</h4>
                      <button
                        className="px-3 py-2 rounded d-inline-flex align-items-center gap-2 bg-red-50 border border-red-200 shadow-sm hover:bg-red-100 transition-all"
                        onClick={() => handleViewNotes(tempPrescription)}
                        style={{ maxWidth: "max-content" }}
                      >
                        <TbInfoTriangle className="text-danger" size={20} />
                        <span className="fw-semibold text-red-700">Notes</span>
                      </button>
                    </div>
                    <section className="doctorsec-pad share-medical pb-0">
                      <div className="container">
                        <div className="card">
                          <div className="card-body doctor-table-card">
                            <div className="table-responsive">
                              <table className="doctor-list-table table table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="row">Page</th>
                                    <th>Name of Drug</th>
                                    <th>Strength</th>
                                    <th>Strength Type</th>
                                    <th>Unit</th>
                                    <th>Form</th>
                                    <th>Dose</th>
                                    <th>Frequency</th>
                                    <th>Intakes or Applications</th>
                                    <th>Route</th>
                                    <th>Refills</th>
                                    <th>Quantity</th>
                                    <th>Comments</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tempPrescription &&
                                    tempPrescription?.map((item, index) => {
                                      return (
                                        <tr id={item?.id} key={index}>
                                          <td scope="row">{index + 1}</td>
                                          <td>
                                            <h3 className="doc-details">
                                              {item?.medicine_name}
                                            </h3>
                                          </td>

                                          <td>{item?.strength}</td>
                                          <td>{item?.strength_type}</td>
                                          <td>{item?.unit}</td>
                                          <td>
                                            {item?.form || item?.medicine_type}
                                          </td>
                                          <td>{item?.dose}</td>
                                          <td>{item?.frequency}</td>
                                          <td>
                                            {item?.intakes_applications ||
                                              item?.intake}
                                          </td>
                                          <td>{item?.route}</td>
                                          <td>{item?.refills}</td>
                                          <td>{item?.quantity}</td>
                                          <td>{item?.comments}</td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                            <PocPrescriptionWrpper className="d-flex mt-3 align-items-center justify-content-between flex-wrap gap-10">
                              <button
                                onClick={() =>
                                  handleQRCode("temp-prescription")
                                }
                                className="submit-btn d-inline-flex justify-content-center"
                                style={{ maxWidth: "max-content" }}
                              >
                                QR Codes
                              </button>

                              {(meetingData?.check && <></>) || (
                                <button
                                  className="submit-btn justify-content-center"
                                  style={{ maxWidth: "max-content" }}
                                  onClick={handleSendRx}
                                >
                                  Send Rx
                                </button>
                              )}
                              <button
                                onClick={() =>
                                  handlePatientInfo("temp-prescription")
                                }
                                className="submit-btn d-inline-flex justify-content-center"
                                style={{ maxWidth: "max-content" }}
                              >
                                Patient Info
                              </button>
                              <button
                                disabled={!patientid}
                                onClick={() => autoPrescription("temp_pres")}
                                className={
                                  !patientid
                                    ? "submit-btn d-inline-flex justify-content-center disabled"
                                    : "submit-btn d-inline-flex justify-content-center"
                                }
                                style={{ maxWidth: "max-content" }}
                              >
                                Auto Prescription
                              </button>
                              <button
                                onClick={() =>
                                  isOpenMailModal(tempPrescription)
                                }
                                className={
                                  tempPrescription?.length === 0
                                    ? "submit-btn d-inline-flex justify-content-center disabled"
                                    : "submit-btn d-inline-flex justify-content-center"
                                }
                                style={{
                                  maxWidth: "max-content",
                                }}
                                disabled={tempPrescription?.length === 0}
                              >
                                Mail Prescription
                              </button>

                              <button
                                onClick={() =>
                                  // handlePatientInfo("temp-prescription")
                                  handlePatientEditInfo("temp-prescription")
                                }
                                className="submit-btn d-inline-flex  justify-content-center"
                                style={{ maxWidth: "max-content" }}
                              >
                                Doctor Info
                              </button>
                            </PocPrescriptionWrpper>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

const PocPrescriptionWrpper = styled.div`
  @media (max-width: 480px) {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    button {
      width: 100%;
      max-width: 100% !important;
    }
  }
`;

export default MeetingStatus;
